import Btn from './Button';
import decodeUriComponent from 'decode-uri-component';
import logo from '../logo.svg';
import  {React, useState, useEffect } from 'react';
import hostages from '../res/134.svg';
import logoNight from '../logo_night.svg';
import { useTranslation } from 'react-i18next';
const About = (props) => {
    
  function isNight() {
    return props.cssClasses.includes("night");   
    
  } 
    const { t, i18n } = useTranslation();    
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const customStyles = {
          width: screenWidth < 1500 ? '100%': '35% !important',
          direction:'rtl',
          
        
      };
    useEffect(() => {
            const handleResize = () => {
                setScreenWidth(window.innerWidth);
                //alert(window.innerWidth);
    
            };
            
            handleResize();
            window.addEventListener('resize', handleResize);
    
            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('resize', handleResize);
            };
            
            }, []); // Empty dependency array means this effect runs once on mount
    var logoToDisplay = logo; 
    return (
        <div id="container" style={customStyles} className="container-fluid single-component-fluid App">
                <header
                          className={"App-header row mb-2 " + (props.langcode === 1 ? "rtl" : "")}
                        >
                          <div className="row ">
                            <div className="col-12 ">
                              <div className="AppHeader">
                                <div className="App-logo-container"><a href={`/`}><img src={logoToDisplay} className="App-logo" alt="logo"/></a></div>
                                 {t("SLOGAN")}{" "}
                                - {t("WEBSITE_TITLE")}
                
                              </div>
                            </div>
                          </div>
                        </header>
                 <h1>אודות</h1>
                        <div className={"row " + (props.langcode === 1 ? "rtl" : "")}>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                <div className="white_box text-align-start">
                                ענן שגדל אל מול העניים  לעמוד ענקי של שלושה קילומטרים . הפלא  שנקרא גשם ,שלצערי לא נראה במחוזותינו יותר מדי. והשלג המופלא, הקצפת שבכל הסיפור. אלה  תמיד  ריתקו אותי - מאז שאני זוכר את עצמי  (שזה  די הרבה זמן). את האתר הקמתי ביולי-2002  מתוך רצון לשתף מידע ולהציג אותו בצורה אינטואיטיבית מצד אחד ומעמיקה מצד שני.<br/> השורשים נטעו בילדות והבשילו לתואר במדעי האטמוספירה. <br/>  עבדתי בעברי כחזאי בשירות המטאורולוגי. כיום אני מחלק את זמני בין האתר לעיסוק השני שלי. <br/> תמונות של התחנה אפשר למצוא באלבום. את התחנה אפשר לרכוש באינטרנט  ב-500 דולר . הנתונים מועברים ישירות מהתחנה והתחזית מיוצרת על-ידי תוך שימוש באנליזה של מפות סינופטיות המיוצרות על-ידי מודלים נומריים.			
                                </div>
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/0kjAhi4tAfU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                 <iframe width="560" height="315" src="https://www.youtube.com/embed/nDJAuCwoKOs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                            </div>
                        </div>
                        <div className={"row " + (props.langcode === 1 ? "rtl" : "")}>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                    <div className="white_box float">
                                    <a href="https://www.ynet.co.il/environment-science/article/r1db711pjh" target="_blank">מן העתונות 1</a><br />
                                    <a href="http://www.haaretz.co.il/news/weather/1.1642873" target="_blank">מן העתונות 2</a><br />
                                            <a href="https://www.ynet.co.il/articles/0,7340,L-4757512,00.html" target="_blank">מן העתונות 3</a><br />
                                            <a href="https://hotjerusalem.com/tag/%D7%99%D7%A8%D7%95%D7%A9%D7%9E%D7%99%D7%99%D7%9D/" target="_blank">מן העתונות 4</a><br />
                                            <a href="https://www.makorrishon.co.il/nrg/online/54/ART2/048/868.html" target="_blank">מן העתונות 5</a><br />
                                            <a href="https://www.makorrishon.co.il/culture/109103/" target="_blank">מן העתונות 6</a><br />
                                            <a href="https://www.makorrishon.co.il/culture/257429/" target="_blank">מן העתונות 7</a><br />
                                	</div>
                    
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                <img src="https://v2013.02ws.co.il/images/BoazMika.jpg"  width="180" alt=""/>
                                <br/>
                                בועז נחמיה והיורשת	
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                 <img src="https://v2013.02ws.co.il/images/BoazEyal.jpg" width="180" alt=""/>
                                <br/>
                                ועוד יורש		
                            </div>
                        </div>
                        <div className={"row " + (props.langcode === 1 ? "rtl" : "")}>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                     <img src="https://v2013.02ws.co.il/images/james.jpg" width="400" alt=""/>
                                <br/>
                                <span> וזה שגורם לניתוקים באתר, אבל הוא מת, ...</span>
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                
                                        <img src="https://v2013.02ws.co.il/images/venice.jpg" width="400" alt=""/>
                                    <br/>
                                    <span> וכלבת ירושמיים שאחראית לתמונות בשעות מוזרות, גם מתה</span>
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                
                            </div>
                        </div>
                        <div className={"row " + (props.langcode === 1 ? "rtl" : "")}>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                 
                                <img src="https://v2013.02ws.co.il/images/rain_gauge_1.jpg" alt="rain_gauge" width="400"/>
                                <img src="https://v2013.02ws.co.il/images/mountain_station.jpg" alt="mountain station" width="400" />
                                <img src="https://v2013.02ws.co.il/images/station_snow.jpg" alt="rain_gauge_snow" width="400" /><br/>
                                 
                                        
                                                        והתחנה בכבודה ועצמה:<br/>
                                        תחנה אלחוטית על הגג עם סנסורים של: 
                        טמפרטורה, לחות, קרינה , יו וי, גשם ומאוורר שמערבל את האוויר.
                        תחנת הר, תחנת עמק ותחנת כביש.
                        מחשב ששואב את הנתונים ממקום האכסון ומשדר אותם לאתר כל דקה.


                                                    
                                        
                            </div>
                            <div className="col-xs-4 col-md-6 col-lg-4  ">
                                 <h2>מיקום</h2>
                                <a href="images/Nayot.jpg" title="מיקום" className="colorbox cboxElement">
                                    <span></span>
                                            <img src="https://v2013.02ws.co.il/images/Nayot.jpg" width="500px" />
                                </a>
                            </div>
                        </div>
                        
            
                <div className={"row " + (props.langcode === 1 ? "rtl" : "")}>
                    <p>
                על גבי הכדור הייתי פחות או יותר במקומות המסומנים<br/>
                        </p><div >
                            <iframe src="https://www.mytravelmap.xyz/u/gg115726297130259560708?5" scrolling="auto" id="iframemain" className="base" allowtransparency="true" marginheight="0" marginwidth="0" width="100%" height="2200" frameborder="0"></iframe> 
                        </div>
                </div>
                
    </div>
         

        
    );
}

export default About; 